import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { salesInvoiceViewAction } from "../../../redux/actions/sales-action";
import CreateEditViewSalesInv from "../../../components/sales-section/sales-invoice/create-edit-view-sales-Inv";
const SalesInvoiceEdit = () => {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(salesInvoiceViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  const [searchParams] = useSearchParams();
  const isNew = searchParams.has("new");
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true} title="Edit Sales Invoice">
          <CreateEditViewSalesInv
            clickedplus={isNew}
            payto={orderDetail?.orderData?.soit_pay_to_address}
            shipto={orderDetail?.orderData?.soit_ship_to_address}
            pageType="invoice"
            page="edit"
            type={"delivery"}
            standAlone={true}
            disabled={
              true && orderDetail?.orderData?.soit_order_status !== "draft"
            }
            orderDetail={orderDetail?.itemData}
            vendorDetails={[orderDetail?.orderData]}
          />
        </InnerLayout>
      )}
    </>
  );
};
export default SalesInvoiceEdit;
